import { defineMessages, IntlShape } from "react-intl";

import BoundaryDataSet from "@mapmycustomers/shared/enum/boundaryLegends/BoundaryDataSet";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages<BoundaryDataSet>({
  [BoundaryDataSet.MEDIAN_INCOME]: {
    id: "boundaryDataset.income",
    defaultMessage: "Median Income",
  },
  [BoundaryDataSet.POPULATION]: {
    id: "boundaryDataset.population",
    defaultMessage: "Total Population",
  },
});

const getBoundaryDatasetDisplayName = (intl: IntlShape, dataset: BoundaryDataSet) =>
  getDisplayName(intl, messages, dataset, "BoundaryDataSet");

export default getBoundaryDatasetDisplayName;
